export const environment = {
  production: true,
  apiEndpoint: "https://service.drivequant.com/v2/",
  crashApiEndpoint: "https://service.drivequant.com/crash/v1",
};
